import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function PrimaNotaPage() {
  const [cfg, setCfg] = useState(null);
  const [editingAnno, setEditingAnno] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const c = await api.get("/pn/config");
      setCfg(c.data);
      setEditingAnno(c.data?.anno_scolastico || "");
    } catch (e) { setMsg(e.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const salvaAnno = async () => {
    try {
      await api.put("/pn/config", { anno_scolastico: editingAnno });
      setMsg("✓ Anno scolastico aggiornato");
      await load();
      setTimeout(() => setMsg(null), 2500);
    } catch (e) { setMsg("✗ " + (e.response?.data?.detail || "Errore")); }
  };

  return (
    <div>
      <div className="sw-page-title">
        <h1>📒 Prima Nota</h1>
        <button onClick={load} data-testid="pn-reload" disabled={loading}
          style={{ padding: "5px 12px", background: "#00695c", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer" }}>
          ↻ Aggiorna
        </button>
      </div>

      <div style={{ margin: "8px 20px", padding: 12, background: "white", border: "1px solid #ccc", display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#00695c" }}>Anno scolastico operativo:</div>
        <input type="text" value={editingAnno} onChange={e => setEditingAnno(e.target.value)} data-testid="pn-anno-input"
          placeholder="es. 2025/26"
          style={{ padding: "5px 10px", border: "1px solid #00695c", fontSize: 13, fontWeight: 700, color: "#00695c", width: 120, textAlign: "center" }} />
        <button onClick={salvaAnno} data-testid="pn-anno-save"
          style={{ padding: "5px 12px", background: "#00695c", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          💾 Salva
        </button>
        {cfg?.anno_scolastico && (
          <span style={{ fontSize: 11, color: "#555", marginLeft: 6 }}>Attuale: <b style={{ color: "#00695c" }}>{cfg.anno_scolastico}</b></span>
        )}
        {msg && <span style={{ fontSize: 12, color: msg.startsWith("✓") ? "#2e7d32" : "#c62828", fontWeight: 700, marginLeft: 10 }}>{msg}</span>}
      </div>
    </div>
  );
}
